import { Component, Input, OnChanges } from '@angular/core';

import { Address } from '@digital-platform/shared/domain';

@Component({
  selector: 'digital-platform-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss'],
})
export class AddressComponent implements OnChanges {
  @Input() public address: Address;
  @Input() public showCounty = false;
  @Input() public oneLine = false;

  public hasStreetAddress: boolean;
  public addressLine1: string;
  public addressLine2: string;
  public addressLine3: string;
  public county: string;
  public city: string;
  public stateCode: string;
  public postalCode: string;
  public country: string;

  public addressOneline: string;

  ngOnChanges(): void {
    const {
      addressLine1,
      addressLine2,
      addressLine3,
      city,
      county,
      stateCode,
      postalCode,
      postalCodeSuffix,
      country,
    } = this.address || {};

    this.hasStreetAddress = !!(addressLine1 || addressLine2 || addressLine3);
    this.addressLine1 = addressLine1 || '';
    this.addressLine2 = addressLine2 || '';
    this.addressLine3 = addressLine3 || '';
    this.city = city || '';
    this.county = county || '';
    this.stateCode = stateCode || '';
    this.postalCode =
      `${postalCode ? postalCode : ''}${
        postalCode && postalCodeSuffix ? `-${postalCodeSuffix}` : ''
      }` || '';
    this.country = country || '';

    // use a temp var to only set public prop once
    let addressOneline = '';

    addressOneline = `${addressOneline}${
      addressOneline && this.addressLine1 ? ', ' : ''
    }${this.addressLine1}`;
    addressOneline = `${addressOneline}${
      addressOneline && this.addressLine2 ? ', ' : ''
    }${this.addressLine2}`;
    addressOneline = `${addressOneline}${
      addressOneline && this.addressLine3 ? ', ' : ''
    }${this.addressLine3}`;

    addressOneline = `${addressOneline}${
      addressOneline && this.city ? ', ' : ''
    }${this.city}`;

    if (this.showCounty) {
      addressOneline = `${addressOneline}${
        addressOneline && this.county ? ', ' : ''
      }${this.county}`;
    }

    addressOneline = `${addressOneline}${
      addressOneline && this.stateCode ? ', ' : ''
    }${this.stateCode}`;

    if (this.postalCode) {
      if (this.stateCode) {
        addressOneline = `${addressOneline} ${this.postalCode}`;
      } else {
        addressOneline = `${addressOneline}, ${this.postalCode}`;
      }
    }

    addressOneline = `${addressOneline}${
      addressOneline && this.country ? ', ' : ''
    }${this.country}`;

    this.addressOneline = addressOneline;
  }
}
